module.exports = {
      id: "icon-premium-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-premium",
      toString: function () {
        return this.url;
      }
    }